import { z } from 'zod';

// Role enum — used by RLS policies, route guards, and the JWT custom claims.
// Keep in sync with the Postgres enum in supabase/migrations/0001_init.sql.

export const roleSchema = z.enum(['admin', 'faculty', 'parent', 'dancer']);
export type Role = z.infer<typeof roleSchema>;

// Convenience predicates — match supabase JWT custom-claim pattern.
export const ROLE_ADMIN = 'admin' as const satisfies Role;
export const ROLE_FACULTY = 'faculty' as const satisfies Role;
export const ROLE_PARENT = 'parent' as const satisfies Role;
export const ROLE_DANCER = 'dancer' as const satisfies Role;

export function isAdministrative(role: Role): boolean {
  return role === ROLE_ADMIN;
}

export function canMarkAttendance(role: Role): boolean {
  return role === ROLE_ADMIN || role === ROLE_FACULTY;
}

export function canEditBilling(role: Role): boolean {
  return role === ROLE_ADMIN;
}
